import { render } from "./LeaveList.vue?vue&type=template&id=49327a60&scoped=true&ts=true"
import script from "./LeaveList.vue?vue&type=script&lang=ts"
export * from "./LeaveList.vue?vue&type=script&lang=ts"

import "./LeaveList.vue?vue&type=style&index=0&id=49327a60&lang=scss&scoped=true"

import exportComponent from "/home/runner/_work/SDD-gotime-web-client/SDD-gotime-web-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49327a60"]])

export default __exports__